import { render, staticRenderFns } from "./BtnEnviarSolicitacao.vue?vue&type=template&id=390ba9f2"
import script from "./BtnEnviarSolicitacao.vue?vue&type=script&lang=js"
export * from "./BtnEnviarSolicitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports